import React from "react";
import AnimateHeight from "react-animate-height";
import Arrow from "@Components/Icons/Arrow";
import Tick from "@Components/Icons/Tick";
import styles from "./index.module.scss";
export default class Card extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            open: props.open === undefined ? true : props.open,
        };
    }
    onToggle() {
        const { open } = this.state;
        this.setState({
            open: !open,
        });
        if (this.props.onToggle) {
            this.props.onToggle(!open);
        }
    }
    componentDidUpdate(previousProps) {
        if (previousProps.open !== this.props.open) {
            this.setState({ open: this.props.open });
        }
    }
    render() {
        const { className = "", completed = false } = this.props;
        const isOpen = this.state.open !== false;
        const isCompletedCollapsed = completed && !isOpen;
        return (React.createElement("div", { className: `${styles.card} ${isOpen ? styles.expanded : styles.collapsed} ${isCompletedCollapsed ? styles.completedCollapsed : ""} ${className}` },
            (this.props.title || this.props.collapsible) && (React.createElement("div", { className: `${styles.header} 
                        ${isOpen === false ? styles.closedHeader : ""} 
                        ${this.props.children === undefined
                    ? styles.closedHeader
                    : ""} 
                        ${this.props.sticky === true ? styles.sticky : ""} ${this.props.collapsible === true
                    ? styles.collapsible
                    : ""}`, onClick: this.props.collapsible && this.onToggle.bind(this) },
                React.createElement("div", { className: styles.left },
                    this.props.title && (React.createElement("div", { className: styles.titleWrapper },
                        typeof this.props.number === "number" ? (React.createElement("ol", { className: styles.numberedTitle, start: this.props.number },
                            React.createElement("li", null,
                                React.createElement("span", { className: styles.titleText }, this.props.title)))) : (React.createElement("h2", { className: styles.title }, this.props.title)),
                        this.props.subTitle && (React.createElement("div", { className: styles.subTitle }, this.props.subTitle)))),
                    this.props.rightSide && (React.createElement("div", { className: `${styles.rightSide} ${isOpen === false
                            ? styles.hiddenOnTablet
                            : ""}` }, this.props.rightSide))),
                React.createElement("div", { className: styles.right },
                    isCompletedCollapsed && (React.createElement("div", { className: styles.completedIcon },
                        React.createElement(Tick, { success: true, size: "20px" }))),
                    this.props.collapsible && (React.createElement("div", { className: `${styles.arrow} ${isCompletedCollapsed
                            ? styles.completedArrow
                            : ""}` },
                        React.createElement(Arrow, { size: `12px`, success: !isCompletedCollapsed, rotate: this.state.open === true
                                ? -270
                                : -360 })))))),
            React.createElement(AnimateHeight, { className: styles.animateHeight, height: this.state.open ? "auto" : 0 }, this.props.children || React.createElement(React.Fragment, null))));
    }
}
